<cap-input-number
  [formControl]="formControl"
  [prefix]="props.prefix"
  [suffix]="props.suffix"
  [placeholder]="props.placeholder"
  [label]="props.label"
  [useGrouping]="props.useGrouping || true"
  [locale]="props.locale || 'nl'"
  [min]="props.min"
  [max]="props.max" />
